module.exports = __webpack_public_path__ + "media/images/japan/tips_5-21660a38426fce71336e8ad4c0566fc7.jpg";